module.exports = __webpack_public_path__ + "static/img/enBanner.0a1a067.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/enBanner.jpg
// module id = f4EC
// module chunks = 1